import { useContext } from "react";
import { AuthDispatchContext } from "./context";

export function useAuthStateDispatcher() {
  return useContext(AuthDispatchContext);
}
